<h4 class="page-header title-300"><b>Alteração da Senha do Nota Premiada Bahia</b></h4>

<!-- Card Flex -->
<div class="row">
  <div class="col-12">
    <div class="alert alert-info" role="alert">
      <h5>Senha Alterada Com Sucesso!</h5>
      Sua senha foi alterada com sucesso!
    </div>
  </div>
</div>
<!-- //.Card Flex -->

<h5 class="page-header title-300"><b>Atualize suas informações de segurança</b></h5>

<div class="card-body">
  <div class="row">
    <div class="col-sm-12">
        <p>Caso ocorra um problema com a sua conta, estas informações facilitarão o retorno ao seu cadastro da Nota Premiada Bahia:</p>
        
        <div class="col-12" *ngIf="consumidor != null || consumidor != undefined">
            <p>Nome: <b>{{ consumidor.nome }}</b> </p>
            <p>CPF:  <b>{{ consumidor.cpf | cpfMask }}</b> </p>    
        </div>

        <h5 class="title-300"s><b>E-mails de Contato</b></h5>
        
        <p>Sempre cadastre os e-mails de contato adicionais. Isto protege a sua conta, caso não tenha mais acesso ao seu endereço de e-mail principal.</p>
                
        <h5 class="title-300"><b>Frase de Segurança</b></h5>
        
        <p class="justify">Cadastre uma frase de segurança (texto de sua escolha) que você a reconheça ao ler. Esta frase aparecerá em todas as mensagens 
          enviadas pela Campanha Nota Premiada Bahia para os seus e-mails, de modo que você tenha segurança da autenticidade do remetente. Sempre que
           receber um e-mail da Campanha Nota Premiada Bahia, confira a frase de segurança informada na mensagem. Caso ela não exista ou esteja 
           incorreta, não abra a mensagem e proceda a sua exclusão.</p>
        
    </div>

    <div class="col-sm-12">
      <button type="button" class="btn btn-bluelight" (click)="onClick()">
        Ir para o meu cadastro
      </button>  
    </div >
  </div>
</div>


<br>


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-msg-senha-alterada/consumidor-msg-senha-alterada.component.html